module.exports = __webpack_public_path__ + "static/media/person.37adc065.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person.svg
// module id = 1085
// module chunks = 1